import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band, BandType as BandTypeEnum } from "../../types/bands"
import { useBandEditForm } from "./BandEditFormContext"
import { BAND_TYPE_LABELS } from "./BandType"

interface BandNameProps {
  band: Band
}

export const BandName: React.FC<BandNameProps> = ({ band }) => {
  const { form } = useBandEditForm()
  const bandType = form.watch("band_type") as BandTypeEnum
  const bandTypeNice = BAND_TYPE_LABELS[bandType] || band.band_type_nice

  const fieldData = {
    field: "name",
    name: "bandName",
    label: `${bandTypeNice} Name (required)`,
    placeholder: `Your ${bandTypeNice} name`,
    required: true,
  }

  return <EditBandFormField type="text" fieldData={fieldData} />
}
